import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["readOnly", "disabled", "enableTime", "enableSeconds", "noCalendar", "dateFormat", "value", "valueDate", "disable", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import flatpickr from 'flatpickr';
import { useTranslation } from 'react-i18next';
import { nsform } from "../../../../../i18n/namespaces";
import { dayjs } from "../../../../date";
import { getFlatpickrLocale } from "./input-flatpickr.utils";
import { defaultFlatpickrDateFormat } from "./input-flatpickr.vm";
import 'flatpickr/dist/flatpickr.min.css';
import "./input-flatpickr.style.scss";
import { multiRef } from '@isyc-react/core/utils/reference';
export const InputFlatpickrInline = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      readOnly,
      disabled: disabledProp,
      enableTime: enableTimeProp,
      enableSeconds: enableSecondsProp,
      noCalendar: noCalendarProp,
      dateFormat = defaultFlatpickrDateFormat,
      value,
      valueDate,
      disable,
      dataTestId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    i18n
  } = useTranslation(nsform.common);
  const inputRef = React.useRef(null);
  const instanceRef = React.useRef(null);

  // using refs in order to allow
  // const
  const disabled = React.useMemo(() => Boolean(disabledProp) || Boolean(readOnly), [disabledProp, readOnly]);
  const enableTime = React.useMemo(() => enableTimeProp !== null && enableTimeProp !== void 0 ? enableTimeProp : dateFormat.includes('H') || dateFormat.includes('m'), []);
  const enableSeconds = React.useMemo(() => enableSecondsProp !== null && enableSecondsProp !== void 0 ? enableSecondsProp : dateFormat.includes('s'), []);
  const noCalendar = React.useMemo(() => noCalendarProp !== null && noCalendarProp !== void 0 ? noCalendarProp : !dateFormat.includes('Y'), []);
  React.useEffect(() => {
    if (inputRef.current) {
      const currentDate = new Date();
      const instance = flatpickr(inputRef.current, _objectSpread(_objectSpread({
        disableMobile: true,
        mode: 'single',
        // Just for default mode
        defaultHour: currentDate.getHours(),
        defaultMinute: currentDate.getMinutes()
      }, rest), {}, {
        dateFormat,
        enableTime: disabled ? false : enableTime,
        enableSeconds,
        noCalendar: disabled || noCalendar,
        disable: [() => disabled, ...(disable !== null && disable !== void 0 ? disable : [])],
        parseDate: (dateStr, format) => {
          return dayjs(dateStr, format, true).toDate();
        },
        formatDate: (date, format) => {
          return dayjs(date).format(format);
        },
        locale: getFlatpickrLocale(i18n.language),
        inline: true,
        allowInput: false,
        position: 'auto center',
        clickOpens: false,
        monthSelectorType: 'dropdown',
        static: true
      }));
      multiRef(ref, instanceRef)(instance);
    }
    // TODO comprobar que no hace falta return y se borra todo al desrenderizar
  }, [disabled, i18n.language]); // TODO comprobar que vaya todo bien aunque tenga dependencias el use effect
  // TODO should change locale on i18n.language change

  // TODO ver como hacer tema value (igual debería ser Date?)
  // TODO ESTO IRIA EN UN PARENT? CON TIPADO 'single' y hacer otro para time, range etc.
  // ejemplo valor en time -> value: {time: '20:15:10', data: { hours: 20, minutes: 15, seconds?: 10}}
  // mirar que ocurre con range y enabletime
  React.useEffect(() => {
    if (instanceRef.current) {
      const isValid = dayjs(value, dateFormat, true).isValid();
      if (isValid && value) instanceRef.current.setDate(value, false, dateFormat);else instanceRef.current.clear();
    }
  }, [value]);
  React.useEffect(() => {
    if (instanceRef.current && valueDate) {
      instanceRef.current.setDate(valueDate, false, dateFormat);
    }
  }, [valueDate]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "input-flatpickr-inline"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    ref: inputRef,
    style: {
      visibility: 'hidden',
      position: 'absolute'
    },
    readOnly: readOnly,
    disabled: disabled,
    "data-test-id": dataTestId
  })));
});